<template>
    <div class="page mw">
        <top-nav :back="false" :logout="true"></top-nav>
        <div class="midCon">

            <div class="jgBar">
                <div class="jgItem" v-for="(item,index) in levArr" :key="index" @click="toggleTab(item.key)">
                    <img class="jgImg" mode="aspectFit" :src="item.icon+(item.key==lev?'':'_')+'.png'" />
                    <div :class="'jgLabel '+(item.key==lev?'jgAtv':'')">{{item.label}}</div>
                </div>
            </div>

            <div class="conBox">
                <div class="subjectBar">
                    <div :class="'subjectItem '+(item.key==subject?'siAtv':'')" v-for="(item,index) in subjectArr" :key="index" @click="toggleSubject(item.key)">{{item.label}}</div>
                </div>

                <div class="jg2Box">
                    <div class="jg2Item" v-for="(item,index) in jgArr" :key="index" @click="jgNavTo(item)">
                        <div class="jg2Icon" :style="'background-color: '+item.bgcolor+';'">
                            <img :src="item.icon" />
                        </div>
                        <div class="jg2Label">{{item.label}}</div>
                    </div>
                    <div class="clear0"></div>
                    <img class="liveBanner" :src="imgHost + '/win/live_banner.png'" @click="toLive()" />
                    <div v-if="tel" class="botTel">{{tel}}</div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    components: {},
    data() {
        return {
            sysName: config.sysName,
            nickName: '',
            imgHost: config.fileHost,
            appHost: config.appHost,

            lev: 'levC',
            levArr: [{
                icon: '/static/images/lev/levc',
                label: 'C1/C2/C3',
                key: 'levC',
            },
            {
                icon: '/static/images/lev/leva1',
                label: 'A1/A3/B1',
                key: 'levA1',
            },
            {
                icon: '/static/images/lev/leva2',
                label: 'A2/B2',
                key: 'levA2',
            },
            {
                icon: '/static/images/lev/levd',
                label: 'D/E/F',
                key: 'levD',
            },
            ],
            subject: 'subject1',
            subjectArr: [
                {
                    label: '科目一（交规）',
                    key: 'subject1',
                },
                {
                    label: '科目四（安全文明驾驶）',
                    key: 'subject4',
                },
                {
                    label: '满分学习',
                    key: 'subject9',
                },
            ],

            jgArr: [
                // {
                //     label: '全部题目',
                //     icon: '/static/images/icon/7.png',
                //     bgcolor: '#ec5e0a',
                //     path: '/pages/study/all_qst/all_qst',
                // },
                {
                    label: '精简题库',
                    icon: '/static/images/icon/1.png',
                    bgcolor: '#fa741f',
                    path: '/study/practice_chapter',
                    param: {
                        type: 1,
                    },
                },
                {
                    label: '考前密卷',
                    icon: '/static/images/icon/2.png',
                    bgcolor: '#00ab7f',
                    path: '/study/practice_chapter',
                    param: {
                        type: 2,
                    },
                },
                {
                    label: '错题库',
                    icon: '/static/images/icon/9.png',
                    bgcolor: '#f23b33',
                    path: '/study/fav_portal?type=1',
                },
                // {
                //     label: '收藏题库',
                //     icon: '/static/images/icon/5.png',
                //     bgcolor: '#fac102',
                //     path: '/study/fav_portal?type=2',
                // },
                // {
                //     label: '模拟考试',
                //     icon: '/static/images/icon/8.png',
                //     bgcolor: '#1871e9',
                //     fun: 'mock',
                //     type: 1,
                // },
                {
                    label: '真实考场',
                    icon: '/static/images/icon/3.png',
                    bgcolor: '#ec5e0a',
                    fun: 'real',
                    type: 2,
                },
                {
                    label: '考试记录',
                    icon: '/static/images/icon/6.png',
                    bgcolor: '#677df7',
                    path: '/study/paper_record',
                },
            ],
            tel: '',
        };
    },
    methods: {
        toggleTab: function (key) {
            this.lev = key;
        },
        toggleSubject: function (key) {
            this.subject = key;
        },
        jgNavTo: function (jg) {
            let _this = this;
            if (jg.fun) {
                if (jg.fun == 'mock' || jg.fun == 'real') {
                    this.$confirm('立刻开始考试？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        _this.newExam(jg.type, jg.fun);
                    }).catch(() => { });
                }
            } else {
                let param = {};
                if (jg.param) {
                    param = jg.param;
                    param.lev = this.lev;
                    param.subject = this.subject;
                }

                this.$router.push({
                    path: jg.path,
                    query: param,
                })
            }
        },
        newExam: function (type, fun) {
            let _this = this;
            let param = {
                type: type,
                lev: this.lev,
                subject: this.subject
            };

            this.req('/ma/paper_record_begin', param, function (data) {
                if (data.success) {
                    if (fun == 'mock') {
                        _this.$router.push({
                            path: '/study/qst_item_exam',
                            query: {
                                rid: data.obj.id
                            },
                        })
                    } else if (fun == 'real') {
                        _this.$router.push({
                            path: '/study/qst_item_real',
                            query: {
                                rid: data.obj.id
                            },
                        })
                    }
                } else {
                    _this.$message.error(data.message);
                }
            })
        },
        toLive() {
            let url = "/live/live_show";

            // 判断是否运行在 NW.js 桌面端
            if (typeof nw !== "undefined") {
                url = this.appHost + url;
                // 桌面APP：外部浏览器打开
                try {
                    nw.Shell.openExternal(url);
                } catch (e) {
                    window.open(url, "_blank");
                }
            } else {
                // 普通浏览器：新标签页打开
                window.open(url, "_blank"); // 新页面
                // window.location.href = url; // 本页面跳转（二选一）
            }
        },
        loadTel: function () {
            let _this = this;
            let types = "SYS_PARAM_CONTACT_TEL";
            this.req("/common/qry_sys_param_mult?types=" + types, {}, function (data) {
                if (data.success) {
                    _this.tel = data.obj['SYS_PARAM_CONTACT_TEL'].value;
                }
            }, "get");
        },
    },
    mounted: function () {

        this.$nextTick(function () {
            let _this = this;
            this.uid = sessionStorage.getItem("mid");
            this.nickName = sessionStorage.getItem("nickName");
            this.loadTel();

        });
    },
    beforeDestroy: function () {
    },
};
</script>
<style scoped>
/* Page container with improved spacing and background */

.midCon {
    display: flex;
    gap: 20px;
}

.jgBar {
    width: 170px;
    background-color: #fff;
    border-radius: 12px;
    padding: 20px 10px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
}

/* Style for level items */
.jgItem {
    cursor: pointer;
    padding: 15px 10px;
    border-radius: 8px;
    margin-bottom: 8px;
    transition: all 0.3s ease;
}

.jgItem:hover {
    background-color: #f0f5ff;
    transform: translateY(-2px);
}

.jgAtv {
    color: #077cf5 !important;
    font-weight: 500;
}

.jgLabel {
    text-align: center;
    font-size: 14px;
    margin-top: 8px;
    color: #666;
    transition: color 0.3s ease;
}

.jgImg {
    width: 48px;
    height: 48px;
    display: block;
    margin: 0 auto;
}

.conBox {
    flex: 1;
    background-color: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
    position: relative;
}

.subjectBar {
    display: flex;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: linear-gradient(to right, #f8f9ff, #f0f4ff);
    border-bottom: 1px solid #eee;
}

.subjectItem {
    flex: 1;
    cursor: pointer;
    transition: all 0.3s ease;
    color: #555;
    font-weight: 400;
}

.subjectItem:hover {
    color: #077cf5;
    background-color: rgba(7, 124, 245, 0.05);
}

.siAtv {
    color: #077cf5;
    font-weight: 500;
    position: relative;
}

.siAtv::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 60%;
    height: 3px;
    background: #077cf5;
    border-radius: 2px;
}

.jg2Box {
    padding: 30px 29px;
    background-color: #fff;
}

.jg2Item {
    width: 160px;
    height: 160px;
    float: left;
    margin: 0 20px 20px 0;
    cursor: pointer;
    border-radius: 12px;
    padding: 15px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.jg2Item:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.jg2Item:nth-child(4n) {
    margin-right: 0;
}

.jg2Icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin: auto;
    padding: 18px;
    box-sizing: border-box;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
}

.jg2Item:hover .jg2Icon {
    transform: scale(1.1);
}

.jg2Icon img {
    width: 44px;
    height: 44px;
}

.jg2Label {
    text-align: center;
    font-size: 15px;
    margin-top: 12px;
    color: #555;
    font-weight: 500;
}

/* Clearfix for grid */
.clear0 {
    clear: both;
}

/* Add this inside the <style scoped> section */
@keyframes pulse-effect {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

.liveBanner {
    width: 400px;
    height: 200px;
    display: block;
    position: absolute;
    z-index: 10;
    bottom: 0px;
    right: 0px;
    cursor: pointer; /* Indicates clickable */
    animation: pulse-effect 1.5s infinite; /* Applies the dynamic effect */
    transition: transform 0.3s ease;
}
.botTel {
    width: 250px;
    height: 30px;
    position: absolute;
    bottom: 10px;
    left: 20px;
    z-index: 10;
    font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue